"use client";

import React from "react";
import { Card as AntdCard } from "antd";

export const Card = AntdCard;
export const CardHeader = ({ children, ...props }: React.ComponentProps<"div">) => (
  <div style={{ marginBottom: 16 }} {...props}>{children}</div>
);
export const CardContent = ({ children, ...props }: React.ComponentProps<"div">) => (
  <div style={{ padding: "0 16px" }} {...props}>{children}</div>
);
export const CardFooter = ({ children, ...props }: React.ComponentProps<"div">) => (
  <div style={{ marginTop: 16 }} {...props}>{children}</div>
);
export const CardTitle = ({ children, ...props }: React.ComponentProps<"div">) => (
  <h4 {...props}>{children}</h4>
);
export const CardDescription = ({ children, ...props }: React.ComponentProps<"div">) => (
  <p style={{ color: "#6b6b6b" }} {...props}>{children}</p>
);
export const CardAction = ({ children, ...props }: React.ComponentProps<"div">) => (
  <div {...props}>{children}</div>
);
